export const STORAGE_KEY = {
  ACCESS_TOKEN: "access_token",
  REFRESH_TOKEN: "refresh_token",
  KEEP_USER: "keep_user",
  IS_REFRESHING: "is_refreshing",
};
